import { useSelector } from 'react-redux';
import { useQuery } from '../routes';
import { fromAccounts } from '../store';

export const useGetTestOpsUrl = (): string => {
  const accountId = useQuery().get('accountId');
  const selectedAccount = useSelector(fromAccounts.selectSelectedAccount);

  if (!selectedAccount) return '';

  const domain = selectedAccount?.domain || `ac-${accountId}`;
  return `https://${domain}.${process.env.REACT_APP_CUSTOM_DOMAIN_POSTFIX}`;
};
